import { BASE_URL } from "../../constants/urls";
import { Request } from "../Request";

export const saveGame = async (data: any) => {
  return Request.post("/game", { data: data });
};

export const getGame = async (id: any) => {
  return Request.get(`/game/${id}`, {});
};

export const getAll = async () => {
  return Request.get(`/game`, {});
};

export const deleteGame = async (id: any) => {
  return Request.del(`/game/${id}`, {});
};

export const getCount = async () => {
  return Request.get(`/games/get-count`, {});
};

export const updateGame = async (id: any, data: any) => {
  return Request.put(`/game/${id}`, { data: data });
};
export const getActive = async () => {
  return Request.get(`/games/get-active`, { noAuth: true });
};

export async function uploadImage(image: File) {
  const formData = new FormData();
  formData.append("image", image);
  try {
    const response = await fetch(`${BASE_URL}/media`, {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      alert("Something went wrong! Try Again.");
    }
  } catch (error) {
    alert("Something went wrong! Try Again.");
  }
}
